// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"84cdfe6c01ecf0c3f8ab","678":"0d796fd908de0f661227"}[chunkId] + ".js";
};